import Dexie from "dexie";

// Create a new Dexie database instance             
const db = new Dexie("CCIDatabase");

db.version(1).stores({
  users: "++id, name, email",
  projects: "++id, name, manager, location, inspection_count",
  inspections: "++id, projectId, inspection_number, date, status, created_at, updated_at, inspector_id",
  disciplines: "++id, name, type, createdTime, added_by_name",
  inspectionTypes: "++id, name, discipline_id",
  comments: "++id, comment, discipline_id, createdTime",
  deficiencies: "++id, inspection_id, deficiency_date, corrected_date",
  siteRepresentatives: "++id, inspection_id, name, companyName",
});

export default db;
